module.exports = __webpack_public_path__ + "static/media/thumbnail_bad_nutrients.ce6fb6bc.png";